import { useState } from 'react';

import { useDispatch } from 'react-redux';

import axiosPrivate from 'config/axiosPrivate';

import { animationUrl } from 'config/endpoints';

import { transformToSemanticGap } from 'helpers/FormatKeywordsHelper';
import { isValidFormat } from 'helpers/PdfFunction';

import { updateForm } from 'store/Writer/Analyser';
import { updateTextOfTextList } from 'store/Writer/OrderDisplay';
import { fetchWriterOrderDisplay } from 'store/Writer/OrderDisplay/features';

export const useWriterDeliverText = ({
  t,
  textType,
  combinedKeywords,
  setErrorSuccessMsg,
  setIsSuccess,
  setErrorSuccess,
  titleTag,
  metaDescriptionTag,
  setIsFetchLoading,
  actualHtmlContent,
  actualTextContent,
  semanticScore,
  initialHtmlContent,
  initialTextContent,
  keyword,
  textTitle,
  actualTextWordCount,
  initialTextWordCount,
  url,
  websites,
  setErrorSuccessImg,
  orderId,
  formData,
  orderType,
  orderContentType,
}) => {
  const [isTextDelivered, setIsTextDelivered] = useState(false);
  const [orderTextsList, setOrderTextsList] = useState([]);

  const dispatch = useDispatch();

  const deliverText = async (
    reinitilazedActualHtmlContent = '',
    finalHtmlContent
  ) => {
    const isKeywordsValid =
      textType !== 'TRANSLATED' ? isValidFormat(combinedKeywords) : {};
    const isSmartWithReviewGMB =
      orderType === 'SMART_WITH_REVIEW' && orderContentType === 'GMB';

    if (!isKeywordsValid && !isSmartWithReviewGMB) {
      setErrorSuccessMsg(
        ` ${t(
          'Veuillez corriger le format de votre gap sémantique afin de pouvoir sauvegarder le texte en brouillon'
        )}. `
      );
      setIsSuccess(false);
      setErrorSuccess(true);
      return;
    }

    const titleLength = titleTag ? titleTag.length : 0;
    const metaDescriptionLength = metaDescriptionTag
      ? metaDescriptionTag.length
      : 0;

    if (
      !isSmartWithReviewGMB &&
      (titleLength <= 5 || metaDescriptionLength <= 5)
    ) {
      setErrorSuccessMsg(
        ` ${t(
          'La taille du titre et/ou la méta-description est trop courte'
        )}. `
      );
      setIsSuccess(false);
      setErrorSuccess(true);
      return;
    }
    setIsFetchLoading(true);
    const contentToSave =
      finalHtmlContent !== undefined ? finalHtmlContent : actualHtmlContent;
    let data = {
      activeInitialText: false,
      actualHtmlContent:
        reinitilazedActualHtmlContent.length > 0
          ? reinitilazedActualHtmlContent
          : contentToSave,
      actualTextContent: actualTextContent,
      analyseResult:
        semanticScore &&
        JSON.stringify({
          semanticEnrichment: semanticScore,
        }),
      initialHtmlContent: initialHtmlContent,
      initialTextContent: initialTextContent,
      keyword: keyword,
      metaDescriptionTag: metaDescriptionTag,
      semanticGap: transformToSemanticGap(combinedKeywords),
      textTitle: textTitle,
      titleTag: titleTag,
      totalNumberOfTextAdded:
        actualTextContent && textType === 'NON_TRANSLATED'
          ? actualTextWordCount - initialTextWordCount
          : actualTextWordCount,

      url: url,
      type: textType,
      stuffedKeywords: [],
      internalLinking: websites,
      initialStuffedKeywords: [],
    };

    const handleSuccess = (res) => {
      setIsFetchLoading(false);
      setIsTextDelivered(true);
      setOrderTextsList(res.data);

      setErrorSuccessMsg(
        `${t('Le texte')} ${textTitle} ${t('a été livré avec succès')}!`
      );
      setErrorSuccessImg(animationUrl + '/05_Contenu_livré.gif');
      setIsSuccess(true);
      setErrorSuccess(true);
    };

    const handleError = (e) => {
      setIsFetchLoading(false);

      switch (e.response.status) {
        case 400:
          setErrorSuccessMsg(
            `${t(
              'Veuillez changer les informations suivantes titre et/ou mot clé'
            )}`
          );
          break;
        default:
          setErrorSuccessMsg(`Oups...! ${t("Une erreur s'est produite")}.`);
          break;
      }
      setIsSuccess(false);
      setErrorSuccess(true);
    };

    const sendTextToServer = (method, url, requestData) => {
      axiosPrivate({
        method,
        url,
        data: requestData,
      })
        .then((response) => {
          if (response.status === 200) {
            dispatch(updateForm(response.data));
            dispatch(fetchWriterOrderDisplay(orderId));

            dispatch(
              updateTextOfTextList({
                id: response.data.id,
                key: 'delivered',
                value: true,
              })
            );
            dispatch(
              updateTextOfTextList({
                id: response.data.id,
                key: 'keyword',
                value: keyword,
              })
            );
          } else {
            throw new Error('Failed to update text information.');
          }
        })
        .then(() => {
          return new Promise((resolve) => setTimeout(resolve, 2000));
        })
        .then(() => {
          return axiosPrivate.get('/texts/' + orderId + '/narrow-details');
        })
        .then((response) => handleSuccess(response))
        .catch((e) => handleError(e));
    };

    const deliverUrl =
      formData === null ? '/texts/deliver' : `/texts/${formData.id}/deliver`;
    const deliverData =
      formData === null ? { ...data, commandId: orderId } : { ...data };

    sendTextToServer(
      formData === null ? 'POST' : 'PUT',
      deliverUrl,
      deliverData
    );
  };

  return {
    deliverText,
    isTextDelivered,
    setIsTextDelivered,
    orderTextsList,
  };
};
